import React from 'react';
import styled from 'styled-components';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { Icon, TypographyComponent as TypographyElement, Link } from '@tvg/fuse-design';
import { DeliveryCardProps } from '../DeliveryAndReturnsProps';

const Container = styled.div`
  display: flex;
  margin-bottom: var(--spacing-space24);
`;

const IconContainer = styled.div<{ withMargin: boolean }>`
  flex: 0 0 32px;
  position: relative;
  top: ${(props) => (props.withMargin ? '-6px' : '0px')};
`;

const TextContainer = styled.div`
  flex: 1;
  margin-left: var(--spacing-space12);
`;

function DeliveryCard(props: DeliveryCardProps) {
  const { onClick, link, text } = props;

  return (
    <Container data-testid="delivery-card">
      <IconContainer withMargin={!link}>
        <Icon icon={<IconLocalShipping />} width="32px" height="32px" dataTestId="delivery-card-icon" />
      </IconContainer>

      <TextContainer>
        <TypographyElement
          tag="p"
          type="paragraph"
          size="m1"
          data-testid="delivery-card-text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />

        {link && (
          <Link
            href="#"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              onClick();
            }}
            data-testid="delivery-card-link"
            size="medium"
            dangerouslySetInnerHTML={{
              __html: link,
            }}
          />
        )}
      </TextContainer>
    </Container>
  );
}

export default DeliveryCard;
